import React, {ReactElement} from 'react'

interface Props {
}

export function RoutesGuest(routesProps: Props): ReactElement {
    const {}: Props = routesProps
    return (<>
    </>)
}
